
export enum CommunicationType {
  Phone = 0,
  Meeting = 1,
  Task = 2,
  Email = 3,
  Note = 4,
  Campaign = 5,
}

export interface MessageInfo {
  sendPdf: boolean;
  uplaod: {
    data: string;
    name: string;
  }[];
  attachDocs: {
    DocEntry: any;
    ObjType: any;
    ModuleId: any;
    AttachName: any;
  }[];
}

export class CommunicationParameter {
  additionalLayouts?: AdditionalLayout[];
  CommunicationType?: CommunicationType;
  CardCode?: string; // CardCode
  ContactPersonCode?: number;
  Tel?: string;
  Remarks?: string; // Details
  Recontact?: Date; // start date
  StartTime?: Date;
  EndDate?: Date;
  EndTime?: Date;
  Employees?: string[];
  // tslint:disable-next-line: variable-name
  Conversation_Recontact?: Date; // start date
  // tslint:disable-next-line: variable-name
  Conversation_StartTime?: Date;
  // tslint:disable-next-line: variable-name
  Conversation_EndDate?: Date;
  // tslint:disable-next-line: variable-name
  Conversation_EndTime?: Date;
  // tslint:disable-next-line: variable-name
  Conversation_Employees?: string[];
  // tslint:disable-next-line: variable-name
  Meeting_Recontact?: Date; // start date
  // tslint:disable-next-line: variable-name
  Meeting_StartTime?: Date;
  // tslint:disable-next-line: variable-name
  Meeting_EndDate?: Date;
  // tslint:disable-next-line: variable-name
  Meeting_EndTime?: Date;
  // tslint:disable-next-line: variable-name
  Meeting_Employees?: string[];
  // tslint:disable-next-line: variable-name
  Task_Recontact?: Date; // start date
  // tslint:disable-next-line: variable-name
  Task_StartTime?: Date;
  // tslint:disable-next-line: variable-name
  Task_EndDate?: Date;
  // tslint:disable-next-line: variable-name
  Task_EndTime?: Date;
  // tslint:disable-next-line: variable-name
  Task_Employees?: string[];
  // tslint:disable-next-line: variable-name
  Campaign_Recontact?: Date; // start date
  // tslint:disable-next-line: variable-name
  Campaign_StartTime?: Date;
  // tslint:disable-next-line: variable-name
  Campaign_EndDate?: Date;
  // tslint:disable-next-line: variable-name
  Campaign_EndTime?: Date;
  Notes?: string;
  // tslint:disable-next-line: variable-name
  Conversation_Notes?: string;
  // tslint:disable-next-line: variable-name
  Meeting_Notes?: string;
  // tslint:disable-next-line: variable-name
  Task_Notes?: string;
  // tslint:disable-next-line: variable-name
  Note_Notes?: string;
  // tslint:disable-next-line: variable-name
  Note_Employees?: string[];
  // tslint:disable-next-line: variable-name
  Email_Notes?: string;
  // tslint:disable-next-line: variable-name
  Email_Employees?: string[];
  Token?: string;
  MsgId?: string;
  // tslint:disable-next-line: variable-name
  Campaign_Notes?: string;
  Priority?: string;
  DocType?: number;
  ITM_HELP_ISPUP: boolean;

  ITM_ONLINE?: string;

  DocEntry?: string;

  StageId?: string;
  EmailFrom?: string;
  EmailTo?: string[];
  EmailCc?: string[];
  EmailBcc?: string[];
  EmailSubject?: string;
  AttachNames?: string[];
  AttachData?: string[];
  AttachDoc?: AttachedDocument[];
  DocFile?: string;

  To: string[];
  Cc: string[];
  Bcc: string[];
  Subject: string;
  HtmlBody: string;
  trackData = false;
  fromCommunication = false;

  // UDFs?: Dictionary<string,string>;
  // attach
}
export class AttachedDocument {
}
export class AdditionalLayout {
  LayoutId: number;
  ModuleId: number;
  DocEntry: string;
}
